import React, { useEffect, useMemo, useState } from 'react'
import Helper from '../Helper';
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types';
import moment from 'moment';
import useStateRef from 'react-usestateref';
import { Button } from 'react-bootstrap';

const SpecialItemCalenderModalV1 = (props) => {
    const index = props?.index
    const [disabled, setDisabled, disabledRef] = useStateRef(false);
    const [displayDateLiving, setDisplayDateLiving, displayDateLivingRef] = useStateRef()
    const [oneSpecial, setOneSpecial, oneSpecialRef] = useStateRef();
    const formattedDateCurrent = moment(props?.currentData?.oneSpecial?.deliveryDate).format('YYYY-MM-DD HH:mm:ss.SSS');
    const [livingShipMethod, setLivingShipMethod, livingShipMethodRef] = useStateRef();

    const [selectedAlternateDate, setSelectedAlternateDate, selectedAlternateDateRef] = useStateRef();
    const [showDate, setShowDate, showDateRef] = useStateRef();
    const [selectDate, setSelectDate, selectDateRef] = useStateRef();
    const [showOverNight, setShowOverNight, showOverNightRef] = useStateRef(true);

    const weekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    const validShowDate = (showDateRef.current instanceof Date && !isNaN(showDateRef.current)) ? showDateRef.current : new Date();
    // const validSelectedDate = (showDateRef.current instanceof Date && !isNaN(showDateRef.current)) ? showDateRef.current : null;
    const validSelectedDate = (selectDateRef.current instanceof Date && !isNaN(selectDateRef.current)) ? selectDateRef.current : null;
    const firstDayThisMonth = new Date(validShowDate.getFullYear(), validShowDate.getMonth(), 1);
    const dayOfWeek = firstDayThisMonth.getDay();
    const firstDayNextMonth = new Date(validShowDate.getFullYear(), validShowDate.getMonth() + 1, 1);
    const lastDayThisMonth = new Date(firstDayNextMonth - 1);
    const lastDayOfWeek = lastDayThisMonth.getDay();
    const currentMoment = moment();
    const isCurrentMonth = validShowDate.getFullYear() === currentMoment.year() && validShowDate.getMonth() === currentMoment.month();
    const [livingShipMethodPrev, setLivingShipMethodPrev, livingShipMethodPrevRef] = useStateRef(props?.currentData?.oneSpecial?.shippingMethod);
    const [alternateDates1, setAlternateDates1, alternateDates1Ref] = useStateRef([]);
    const [alternateDates2, setAlternateDates2] = useState([]);
    const [blackOutDateslist, setBlackOutDateslist] = useState([]);
    const [deliveryDatelist, setDeliveryDatelist, deliveryDatelistRef] = useStateRef([]);
 //   const [deliveryDateSelect, setDeliveryDateSelect, deliveryDateSelectRef] = useStateRef([]);
    const isDateInAlternateDate = (date, list) => {
        if (list) {
            let unavailableMethodDates = list?.split(' ').map(dates => dates.trim());
            let isUnavailableMethodDate = unavailableMethodDates.includes(date);
           return isUnavailableMethodDate;
        }
    };
    useEffect(() => {
        setSelectedAlternateDate(props.currentData?.oneSpecial?.deliveryDate ? true : false);
        setShowDate(new Date(moment(props.currentData?.oneSpecial?.deliveryDate)));
        setSelectDate(new Date(moment(props.currentData?.oneSpecial?.deliveryDate)));
        setDisplayDateLiving(props?.currentData ? ` ${moment(props.currentData?.oneSpecial?.deliveryDate).format('MMMM DD, YYYY')}` : 'Select a date');
        setOneSpecial(props?.currentData?.oneSpecial);
        setLivingShipMethod(props?.currentData?.oneSpecial?.shippingMethod ?? props?.currentData?.shipType ?? "")
        setLivingShipMethodPrev(props?.currentData?.oneSpecial?.shippingMethod ?? props?.currentData?.shipType ?? "")
        
        setDeliveryDatelist(props?.currentData?.deliveryDate);
        const formattedDateSelect = moment(deliveryDatelistRef?.current).format('MM/DD/YYYY');
        
        const newDeliverySelect = parseDates(formattedDateSelect ?? '');
        // Parse and filter dates
        const newAlternateDates1 = parseDates(props?.currentData?.dates?.alternateDates1 ?? '');
        console.log('altetrnate-----',props?.currentData?.dates?.alternateDates1)
        
        const newAlternateDates2 = parseDates(props?.currentData?.dates?.alternateDates2 ?? '');
        const newBlackOutDateslist = parseDates(props?.currentData?.dates?.blackOutDateslist ?? '');

        // Filter out blackout dates
        setAlternateDates1(newAlternateDates1?.filter(date => !newBlackOutDateslist.includes(date)));
        setAlternateDates2(newAlternateDates2?.filter(date => !newBlackOutDateslist.includes(date)));
        //setDeliveryDateSelect(newDeliverySelect?.filter(date => !newBlackOutDateslist.includes(date)));

        const validSelectedDate = (selectDateRef.current instanceof Date && !isNaN(selectDateRef.current)) ? selectDateRef.current : null;
        
        const formattedDate = moment(validSelectedDate).format('MM/DD/YYYY');
        let isAlternateDate = isDateInAlternateDate(formattedDate, props?.currentData?.dates?.alternateDates1);
       
        if (isAlternateDate) {
            setSelectedAlternateDate(false);
            setLivingShipMethodPrev("Second Day Air")
            setLivingShipMethod('Overnight')
        }
        if(props?.currentData?.dates?.alternateDates1 == ""){
            console.log("altetrnate date is empty");
            setShowOverNight(false)
        }else{
            setShowOverNight(true)
        }
    }, [props.currentData])
    function handleShipMethod(method) {
        if(selectedAlternateDateRef?.current == true && showOverNightRef.current == true && method != livingShipMethodRef.current){
        setLivingShipMethodPrev(livingShipMethodRef.current)
        setLivingShipMethod(method)
        }
    }

    const month = useMemo(() => {
        const days = [];
        for (let d = firstDayThisMonth; d < firstDayNextMonth; d.setDate(d.getDate() + 1)) {
            days.push(new Date(d));
        }
        return days;
    }, [validShowDate]);


    const parseDates = (dateString) => {
        if (!dateString) return [];
        return dateString.split(' ').map(date => {
            const parsedDate = moment(date, 'MM/DD/YYYY', true);
            return parsedDate.isValid() ? parsedDate.toDate() : null;
        }).filter(date => date !== null);
    };

    const isDateInList = (date, list) => {
        if (list && date) {
            return list.some(d => d.getTime() === date.getTime());
        }
    };


    const onChange = (date) => {
        // setShowDate(date)
        setSelectDate(date)
        const formattedDate = moment(date).format('MM/DD/YYYY');
        const unavailableMethodDates = props?.currentData?.dates?.alternateDates1?.split(' ').map(date => date.trim());
        const isUnavailableMethodDate = unavailableMethodDates.includes(formattedDate);
        if (!isUnavailableMethodDate) {
            setSelectedAlternateDate(true);
        } else {
            setSelectedAlternateDate(false);
            if (livingShipMethodRef.current == 'Second Day Air') {
                handleShipMethod(livingShipMethodRef.current)
                setLivingShipMethod('Overnight')
            } else {
                setLivingShipMethod(livingShipMethodRef.current)
            }
        }
        setDisplayDateLiving(moment(date).format('MMMM DD, YYYY'));
    };

    async function handleSpecialCalendar(event) {
        event.preventDefault();
        setDisabled(true)
        var actionUrl = "api/rest/cb/checkout/living-calendar-without-groupname";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({

            selectedShippingMethod: livingShipMethodRef.current,
            currentDate: formattedDateCurrent,
            currentShipMethod: livingShipMethodPrevRef.current,
            selectedDate: moment(displayDateLivingRef.current).format('MM/DD/YYYY'),
            currentcommerceItemId: props?.currentData?.oneSpecial?.commerceItemId ?? '',
            currentSkuId: props?.currentData?.oneSpecial?.itemNumber ?? '',
            currentquantity: props?.currentData?.oneSpecial?.quantity ? String(props?.currentData?.oneSpecial?.quantity) : "0",
            selectedShipGroupId: props?.currentData?.oneSpecial?.shippingGroupId ?? '',
            backOrdered: String(props?.currentData?.oneSpecial?.isBackOrdered)
            
        }))
        if (res.result == "success") {
            var livingModalClose = document.getElementById(`specialCalenderClose${index}`)
            setDisabled(false)
            livingModalClose.click();
            props.handleOrderDetails()
        }
        else {
            setDisabled(false)
            console.log("errorList-----", res)
        }

    };

    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_140;

    }
    return (
        <div>
            <div className="modal gx-0 fade c-shopping-list-modal-body" id={`specialItemModal${index}`} tabindex="-1" aria-labelledby={`specialItemModal${index}`} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                    <div className="modal-content">
                        <button type="button" className="btn-close" id={`specialCalenderClose${index}`} data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body">
                            <div className="c-checkout-calendar" id="calendar">
                                <div className='col-md-12'>
                                    <div className="form-group row px-md-5 py-md-5">
                                        <div className="col-md-7">
                                            <div className="mr-auto title font-weight-bold">

                                                <h1 className="c-account-heading mb-3">
                                                    Change Arrival Date for item
                                                </h1>
                                            </div>

                                            <div className="c-delivery-item">
                                                <span className="c-delivery-img">
                                                    <img onError={replaceImage} src={oneSpecialRef?.current?.imagePath} /></span>
                                                <div className="c-delivery-items">
                                                    <p className="c-delivery-item-text">#{oneSpecialRef?.current?.itemNumber} Qty:{oneSpecialRef?.current?.quantity}</p>
                                                    <p className="c-delivery-item-text">{oneSpecialRef?.current?.productDescription}</p>
                                                </div>
                                            </div>

                                            <div className="" dangerouslySetInnerHTML={{
                                                __html: props?.currentData?.message
                                            }}>
                                            </div>
                                            <form className="mt-4 ml-1">
                                                <h1 className="c-account-heading mb-4">Select shipping method:<p></p>
                                                    <div className="row g-4 c-shipping-box-small" >
                                                        <label className="col-12 col-md-6" htmlFor='livingCalenterDayAir' onClick={() => handleShipMethod("Second Day Air")}>
                                                            <div className={`c-box-shipping ${selectedAlternateDateRef?.current == true && livingShipMethodRef?.current === "Second Day Air" && 'active'}`}>
                                                                {selectedAlternateDateRef?.current == true ?
                                                                    <div className="form-check"> <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="livingCalendarModal"
                                                                        id="livingCalenterDayAir"
                                                                        value="2 Day Air"
                                                                        checked={livingShipMethodRef?.current === "Second Day Air"}
                                                                        defaultChecked={livingShipMethodRef?.current === "Second Day Air"}
                                                                        onChange={() => handleShipMethod("Second Day Air")}
                                                                    /> </div> : ""}

                                                                <div className="c-box-shipping-calendar">
                                                                    <div className="c-box-calendar-info">
                                                                        <p>2 Day Air</p>
                                                                        {selectedAlternateDateRef?.current == false ? <p>(unavailable)</p> : ""}
                                                                    </div>
                                                                    <div className="container-circle">
                                                                        <div className="circle-tick"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </label>

                                                        <label className="col-12 col-md-6" htmlFor='livingCalendarOvernight' onClick={() => handleShipMethod("Overnight")}>
                                                            <div className={`c-box-shipping ${livingShipMethodRef.current === "Overnight" ? 'active' : ''} `}>
                                                                {showOverNightRef.current == true ? 
                                                                    <div className="form-check"> <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="livingCalendarModal"
                                                                        id="livingCalendarOvernight"
                                                                        value="Overnight"
                                                                        checked={livingShipMethodRef?.current === "Overnight"}
                                                                        defaultChecked={livingShipMethodRef?.current === "Overnight"}
                                                                        onChange={() => handleShipMethod("Overnight")}
                                                                    />
                                                                    </div>:""}
                                                                <div className="c-box-shipping-calendar">
                                                                    <div className="c-box-calendar-info">
                                                                        <p>Overnight</p>
                                                                        {showOverNightRef.current == false  ? <p>(unavailable)</p> : ""}
                                                                    </div>
                                                                    <div className="container-circle">
                                                                        <div className="circle-tick"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </h1>
                                            </form>
                                        </div>



                                        <div className="col-12 col-md-5 cb-calendar-modal">
                                            <div className="calendar">
                                                <div className="d-flex justify-content-between cb-month-row">
                                                    <Button className='cb-month-previous'
                                                        onClick={() => setShowDate(new Date(validShowDate.getFullYear(), validShowDate.getMonth() - 1, 1))}
                                                        disabled={isCurrentMonth}>
                                                        <span>&lt;</span>
                                                    </Button>
                                                    <div className='cb-month-cell'>
                                                        {validShowDate.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}
                                                    </div>
                                                    <Button className='cb-month-next' onClick={() => setShowDate(new Date(validShowDate.getFullYear(), validShowDate.getMonth() + 1, 1))} >
                                                        <span>&gt;</span>
                                                    </Button>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    {weekDays.map((weekDay, index) => (
                                                        <div key={index} className="day cb-weekday">
                                                            <small>{weekDay}</small>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="d-flex flex-wrap list-days">
                                                    {Array.from({ length: dayOfWeek }).map((_, index) => (
                                                        <div key={index} className="day cell_day empty_cell_start" style={{ flex: '0 0 14.28%' }}></div>
                                                    ))}
                                                    {month.map((day) => {
                                                        const isAlternateDate1 = isDateInList(day, alternateDates1);
                                                        const isAlternateDate2 = isDateInList(day, alternateDates2);
                                                      //  const deliveryDateDefault = isDateInList(day, deliveryDateSelectRef?.current)
                                                        const highlightSelectedDate =
                                                            validSelectedDate &&
                                                            validSelectedDate.getDate() === day.getDate() &&
                                                            validSelectedDate.getMonth() === day.getMonth() &&
                                                            validSelectedDate.getFullYear() === day.getFullYear();
                                                        // const variant = deliveryDateDefault ? 'onchange-dates' : isAlternateDate1 ? 'onchange-dates' : isAlternateDate2 ? 'onchange-dates' : 'disabled-dates';
                                                        // const disabled = !isAlternateDate1 && !isAlternateDate2 && !deliveryDateDefault;
                                                        const variant =  isAlternateDate1 ? 'onchange-dates' : isAlternateDate2 ? 'onchange-dates' : 'disabled-dates';
                                                        const disabled = !isAlternateDate1 && !isAlternateDate2 ;
                                                        return (
                                                            <div key={day} className="day cell_day cell_of_days">
                                                                <Button
                                                                    variant={highlightSelectedDate ? 'highlight-selected-date' : variant}
                                                                    onClick={() => onChange(day)}
                                                                    className="w-100"
                                                                    disabled={disabled}
                                                                >
                                                                    {day.getDate()}
                                                                </Button>
                                                            </div>
                                                        );
                                                    })}
                                                    {Array.from({ length: 6 - lastDayOfWeek }).map((_, index) => (
                                                        <div key={index} className="day cell_day empty_cell_end" style={{ flex: '0 0 14.28%' }}></div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="cb-delivery-sd m-auto text-center fst-italic" style={{ width: '280px'}}>
                                                <span>Selected Date:</span>
                                                <span id="dateDisplay">{displayDateLivingRef.current}</span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className="col-md-4 text-center  mt-5 mb-md-5 d-grid m-md-auto">
                                        <button id="saveDateSpecial" className="btn btn-primary block" disabled={disabledRef.current == true ? true:""} onClick={handleSpecialCalendar} >SAVE DATE</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SpecialItemCalenderModalV1
